import { useContext, useAsync, computed } from '@nuxtjs/composition-api'

export default () => {
  const { $axios } = useContext()

  const master = useAsync(() =>
    $axios.$get<AllMasterData>('/master_data/generals/all')
  )

  // ========
  // generals
  // ========

  // 年齢
  const ages = computed(() => (master.value ? master.value.generals.age : []))

  // 年収
  const annualIncomes = computed(() =>
    master.value ? master.value.generals.annual_income : []
  )

  // 最終学歴区分
  const educationKinds = computed(() =>
    master.value ? master.value.generals.education_kind : []
  )

  // 卒業区分
  const educationStatuses = computed(() =>
    master.value ? master.value.generals.education_status : []
  )

  // 経験年数
  const experienceYears = computed(() =>
    master.value ? master.value.generals.experience_year : []
  )

  // 性別
  const genders = computed(() =>
    master.value ? master.value.generals.gender : []
  )

  // 業界カテゴリ
  const industryCategories = computed(() =>
    master.value ? master.value.generals.industry_category : []
  )

  // 業種
  const industries = computed(() =>
    master.value ? master.value.generals.industry : []
  )

  // 職種
  const jobCategories = computed(() =>
    master.value ? master.value.generals.job_category : []
  )

  // 職業
  const occupations = computed(() =>
    master.value ? master.value.generals.occupation : []
  )

  // スキルカテゴリ
  const skillCategories = computed(() =>
    master.value ? master.value.generals.skill_category : []
  )

  // スキル
  const skills = computed(() =>
    master.value ? master.value.generals.skill : []
  )

  // ソフトウェア
  const softwares = computed(() =>
    master.value ? master.value.generals.software : []
  )

  // 映像ジャンル
  const videoCategories = computed(() =>
    master.value ? master.value.generals.video_category : []
  )

  // 映像ジャンル
  const videoProductionMinds = computed(() =>
    master.value ? master.value.generals.video_production_mind : []
  )

  // 映像制作の経験
  const workExperiences = computed(() =>
    master.value ? master.value.generals.work_experience : []
  )

  // 雇用形態
  const employmentStatuses = computed(() =>
    master.value ? master.value.generals.employment_status : []
  )

  // 在留資格
  const residenceStatusKinds = computed(() =>
    master.value ? master.value.generals.residence_status_kind : []
  )

  // =======
  // careers
  // =======

  // 転職時期
  const jobChangeTimes = computed(() =>
    master.value ? master.value.careers.job_change_time : []
  )

  // 雇用形態
  const jobOfferEmploymentStatuses = computed(() =>
    master.value ? master.value.careers.job_offer_employment_status : []
  )

  // タグ
  const jobOfferTags = computed(() =>
    master.value ? master.value.careers.job_offer_tag : []
  )

  // 職種
  const offeringJobRoles = computed(() =>
    master.value ? master.value.careers.offering_job_role : []
  )

  // 制作ジャンル
  const productionGenres = computed(() =>
    master.value ? master.value.careers.production_genre : []
  )

  return {
    ages,
    annualIncomes,
    educationKinds,
    educationStatuses,
    employmentStatuses,
    experienceYears,
    genders,
    industryCategories,
    industries,
    jobCategories,
    occupations,
    residenceStatusKinds,
    skillCategories,
    skills,
    softwares,
    videoCategories,
    videoProductionMinds,
    workExperiences,
    jobChangeTimes,
    jobOfferEmploymentStatuses,
    jobOfferTags,
    offeringJobRoles,
    productionGenres
  }
}
